import React from "react";
import { Stack, Typography } from "@mui/material";

const FieldTitle = ({ title }) => (
    <Stack sx={{
        width: 250,
        flexDirection: 'column',
        gap: 0.5
    }}>
        <Typography variant="h5" sx={{ textAlign: 'left', color: '#101828' }}>{title}</Typography>
    </Stack>
);

export default React.memo(FieldTitle);
